import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DefaultList } from "../../../../Constant";
import { DEFAULT_DATA, DEFAULT_LIST } from "../../../../Data/UiKit/Lists";
import { LI, UL } from "../../../../AbstractElements";

const DefaultLists = () => {
  return (
    <Col xl="4" md="6">
      <Card>
        <CommonCardHeader title={DefaultList} span={DEFAULT_DATA} />
        <CardBody>
          <UL>
            <LI><i className="icofont icofont-arrow-right"></i>Logo Design</LI>
            {DEFAULT_LIST.map((item, index) => (
              <LI key={index}><i className="icofont icofont-arrow-right"></i>{item}</LI>
            ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DefaultLists;
